import { type TeamId } from '../model'
import { isDefined } from './isEmpty'

export type SelectPrimaryTeamInput = {
  primaryTeamId?: TeamId
  directTeamIds: TeamId[]
}

/**
 * A user's primary team only counts while they are still a direct member of it.
 * Otherwise fall back to their first direct team, so new records are never stamped
 * with a team the user has left.
 */
export function selectPrimaryTeamId({ primaryTeamId, directTeamIds }: SelectPrimaryTeamInput): TeamId | undefined {
  if (isDefined(primaryTeamId) && directTeamIds.includes(primaryTeamId)) return primaryTeamId
  return directTeamIds.at(0)
}
